export const COMMUNICATION_LINK_TYPES = {
  OUTLOOK_FOLDER: 'outlook_folder',
  TEAMS_GROUP: 'teams_group',
  PLANNER_BOARD: 'planner_board',
};

export const COMMUNICATION_SOURCES = {
  OUTLOOK: 'outlook',
  TEAMS: 'teams',
  PLANNER: 'planner',
};

export const ALIGNMENT_STATUS = {
  ALIGNED: 'aligned',
  CONFLICT: 'conflict',
  PARTIAL: 'partial',
  MISSING: 'missing',
};

/** @typedef {'outlook'|'teams'|'planner'} CommunicationSource */

/**
 * @typedef {Object} CommunicationFeedItem
 * @property {string} id
 * @property {CommunicationSource} source
 * @property {string} threadKey
 * @property {string} threadTopic
 * @property {string} timestamp
 * @property {string} author
 * @property {string} subject
 * @property {string} preview
 * @property {string} body
 * @property {string} [status]
 * @property {string[]} [linkedRefs]
 * @property {string[]} [attachments]
 * @property {Record<string, unknown>} [metadata]
 * @property {string} [decisionPosition]
 */

/**
 * @typedef {Object} PlatformConnection
 * @property {boolean} connected
 * @property {string} name
 * @property {string} [url]
 * @property {string} [externalId]
 * @property {string} [latestActivity]
 * @property {string} [alignmentStatus]
 * @property {number} [unreadCount]
 * @property {number} [openTasks]
 * @property {string} [channel]
 */

/**
 * @typedef {Object} ProjectConnections
 * @property {PlatformConnection} outlook
 * @property {PlatformConnection} teams
 * @property {PlatformConnection} planner
 */

/**
 * @typedef {Object} AlignmentSourceSlice
 * @property {string} excerpt
 * @property {string} author
 * @property {string} timestamp
 * @property {string} [decisionPosition]
 */

/**
 * @typedef {Object} AlignmentConflict
 * @property {string} threadKey
 * @property {string} threadTopic
 * @property {'aligned'|'conflict'|'partial'|'missing'} status
 * @property {Partial<Record<CommunicationSource, AlignmentSourceSlice>>} bySource
 */

/**
 * @typedef {Object} AlignmentQueryResult
 * @property {string} question
 * @property {string} summary
 * @property {string} suggestedResolution
 * @property {string[]} sourcesCited
 */

/**
 * @typedef {Object} CommunicationsSetupConfig
 * @property {{ mode: 'create'|'link', name: string, selectedExistingId?: string, channel?: string }} outlook
 * @property {{ mode: 'create'|'link', name: string, selectedExistingId?: string, channel?: string }} teams
 * @property {{ mode: 'create'|'link', name: string, selectedExistingId?: string, template?: string }} planner
 * @property {string[]} [inviteMemberIds]
 */

/**
 * @typedef {Object} ProductivitySummary
 * @property {number} contractProgressPct
 * @property {number} billableHours
 * @property {number} billableHoursTarget
 * @property {number} teamUtilizationPct
 * @property {number} budgetSpent
 * @property {number} budgetTotal
 * @property {Array<{ id: string, name: string, role: string, hoursWeek: number, billablePct: number, deliverables: number }>} teamRows
 */

export const PLATFORM_THEME = {
  outlook: { accent: '#0078D4', label: 'Outlook' },
  teams: { accent: '#6264A7', label: 'Microsoft Teams' },
  planner: { accent: '#31752F', label: 'Planner' },
};
